import { observable, computed, action, makeObservable } from 'mobx';
import MainStore from '../../../MainStore';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';

class WorkStore {
    isOpen;
    flagDialogTitle;
    work;
    selectedTab;
    prevWorks;
    works;
    workId;
    newFlag;
    isCommentDialogOpen;
    callback;
    commentDialogCallback;
    isCommentRequired;

    constructor() {
        

        this.isOpen = localStorage.getItem("isWorkDialogOpen") === "true";
        this.isCommentDialogOpen = false;
        this.selectedTab = 0;
        if (JSON.parse(localStorage.getItem("openedWork"))) {
            this.work = JSON.parse(localStorage.getItem("openedWork"));
        }
        else {
            this.work = { description: '', sessionId: this.uuidv4() };
            localStorage.setItem("openedWork", JSON.stringify(this.work));
        }
        this.prevWorks = [];
        this.works = [];
        this.flagDialogTitle = '';
        this.workId = '';
        this.newFlag = false;
        this.isCommentRequired = false;
        this.callback = () => { };
        this.commentDialogCallback = null;

        makeObservable(this, {
            isOpen: observable,
            callback: observable,
            commentDialogCallback: observable,
            workId: observable,
            newFlag: observable,
            flagDialogTitle: observable,
            isCommentDialogOpen: observable,
            isCommentRequired: observable,
            work: observable,
            works: observable,
            selectedTab: observable,
            getWorkId: computed,
            isWorkDialogOpen: computed,
            getSelectedTab: computed,
            getFlagDialogTitle: computed,
            getIsCommentDialogOpen: computed,
            getWorks: computed,
            getIsCommentRequired: computed,
            getWork: computed,
            closeWorkDialog: action,
            openWorkDialog: action,
            setSelectedTab: action,
            openCommenDialog: action,
            closeCommentDialog: action,
            setWork: action,
            updateWork: action,
            setCallback: action,
            setWorks: action,
        });
    }

    get isWorkDialogOpen() {
        return this.isOpen;
    }

    get getWork() {
        return this.work;
    }

    get getWorks() {
        return this.works;
    }

    get getIsCommentRequired() {
        return this.isCommentRequired;
    }

    get getSelectedTab() {
        return this.selectedTab;
    }

    setWork(work) {
        this.work = work;
        localStorage.setItem("openedWork", JSON.stringify(work));
    }

    setWorks(works) {
        this.works = works;
    }

    updateWork(work) {
        //var works = this.works.slice(0);

        if (!work.id) {
            this.works.push(work);
        }
        else {
            //var works = this.works.slice(0);
            var index = this.works.findIndex(w => w.id === work.id);
            if (index > -1) {
                //this.works.splice(index, 1);
                //var newPosition = this.works.filter(w => w.position < work.position).length;
                this.works.splice(index, 1, work);
                //this.works = works.sort(this.sort);
            }
            else {
                this.works.push(work);
            }
        }

        //this.works = works;
    }

    sort(a, b) {
        var res = b.priorityOrder - a.priorityOrder;
        return res !== 0 ? res : a.position - b.position;
    }

    setSelectedTab(selectedTab) {
        this.selectedTab = selectedTab;
    }

    get getIsCommentDialogOpen() {
        return this.isCommentDialogOpen;
    }

    get getFlagDialogTitle() {
        return this.flagDialogTitle;
    }

    get getWorkId() {
        return this.workId;
    }

    openCommenDialog(title, workId, newFlag, callback, isCommentRequired) {
        this.isCommentDialogOpen = true;
        this.flagDialogTitle = title;
        this.workId = workId;
        this.newFlag = newFlag;
        this.isCommentRequired = !!isCommentRequired;
        this.commentDialogCallback = callback;
    }

    closeCommentDialog() {
        this.isCommentDialogOpen = false;
    }

    openWorkDialog(work, callback) {
        if (this.work.id) {
            this.prevWorks.push(this.work);
        } 

        if (work.id) {
            this.loadWork(work.id, w => {
                this.work = Object.assign({}, w);
                localStorage.setItem("openedWork", JSON.stringify(w));
                this.isOpen = true;
                localStorage.setItem("isWorkDialogOpen", true)
                this.selectedTab = 0;
                this.callback = callback;
            });
        }
        else {
            this.work = Object.assign({}, work);
            localStorage.setItem("openedWork", JSON.stringify(work));
            this.isOpen = true;
            localStorage.setItem("isWorkDialogOpen", true)
            this.selectedTab = 0;
            this.callback = callback;
        }
    }

    loadWork(id, callback) {
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Work/GetByWorkId?id=' + id,
            null,
            'application/json',
            (result) => {
                MainStore.setMaskUnvisible();
                callback(result);
            },
            'GET'
        );
    }

    setCallback(callback) {
        this.callback = callback;
    }

    closeWorkDialog() {
        
        if (this.prevWorks.length > 0) {
            this.work = this.prevWorks.pop();
            localStorage.setItem("openedWork", JSON.stringify(this.work));
        }
        else {
            this.work = { description: '', sessionId: this.uuidv4() };
            localStorage.setItem("openedWork", JSON.stringify(this.work));
            this.isOpen = false;
            localStorage.setItem("isWorkDialogOpen", "")
        }
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

const workStore = new WorkStore();

export default workStore;
export { WorkStore };